import Guid from "_shared/guids/guid";
import TeamProfileSchema, { TeamProfileJSON, TeamProfileParams } from "marketplace/team-profile/_schema/team-profile-schema";
import Entity from '_framework/entities/entity';

export default class TeamProfile extends Entity<TeamProfile, TeamProfileJSON, TeamProfileParams> {
  public static get EXAMPLE(): TeamProfile {
    return new TeamProfile({
      name: "Test Team",
      description: "This is a test team profile.",
      categories: ["Category1", "Category2"],
      avatarId: Guid.generate(),
      contactUserId: Guid.generate()
    });
  }

  public static create(values: TeamProfileParams): TeamProfile {
    const parsed = TeamProfileSchema.validate(values);
    return new TeamProfile(parsed);
  }

  public static fromJSON(json: TeamProfileJSON): TeamProfile {
    const parsed = TeamProfileSchema.deserialize(json);
    return new TeamProfile(parsed);
  }

  public static fromJSONArray(jsonArray: TeamProfileJSON[]): TeamProfile[] {
    return jsonArray.map((json) => TeamProfile.fromJSON(json));
  }
  
  
  public readonly name: string;
  public readonly description?: string;
  public readonly contactUserId?: Guid;
  public readonly categories: string[];
  public readonly avatarId?: Guid;
  
  constructor(params: TeamProfileParams) {
    super(params);
    this.name = params.name;
    this.description = params.description;
    this.contactUserId = params.contactUserId;
    this.avatarId = params.avatarId;
    this.categories = params.categories ?? [];
  }


  public toJSON(): TeamProfileJSON {
    return TeamProfileSchema.serialize(this);
  }

  public valueOf(): TeamProfileJSON {
    return this.toJSON();
  }

  public toString(): string {
    return `Team: 
        Name: ${this.name},
        Description: ${this.description},
        Categories: ${this.categories?.join(", ")},
        AvatarId: ${this.avatarId},
        ContactUserId: ${this.contactUserId}
      )`;
  }

  public isEqualTo(other: TeamProfile | null | undefined): boolean {
    return Boolean(other
      && this.name === other.name
      && this.description === other.description
      && this.contactUserId?.isEqualTo(other.contactUserId)
      && this.categories.length === other.categories.length 
      && this.categories.every((category, index) => category === other.categories[index])
      && this.avatarId?.isEqualTo(other.avatarId)
    );
  }
}
